module.exports = __webpack_public_path__ + "static/saastory-3D0008-d3bf30f7ea868f6a1cc9b2827b7df57f.png";